import { Component, ElementRef, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  InceptionService,
  LanguageService,
  TranslationService,
} from '@proximus/ng-common';
import { getPiiServiceId } from '@dch/ng-usage';
import { OnDestroyHookDirective } from 'src/app/shared/hooks';
import { GetSplitUnbilledBalance } from 'src/app/store/actions/split-unbilled-balence.actions';
import {
  ApplicationState,
  getSplitUnbilledBalance,
} from 'src/app/store/reducers';
import { SplitUnbilledBalance } from './split-bill.model';

@Component({
  selector: 'mprd-split-bill-detail',
  templateUrl: './split-bill-detail.component.html',
})
export class SplitBillDetailComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  employeeTotalAmount: string;
  employerTotalAmount: string;
  mobilePayment: string;
  employeeInvoice: string;
  lastUpdate: string;
  currencyUnit: string;

  constructor(
    private store: Store<ApplicationState>,
    private translationService: TranslationService,
    private languageService: LanguageService,
    private elementRef: ElementRef,
    private inceptionService: InceptionService,
  ) {
    super();
  }

  ngOnInit(): void {
    const serviceId = getPiiServiceId();
    if (serviceId) {
      this.store.dispatch(new GetSplitUnbilledBalance({ serviceId }));

      this.addSubscription(
        this.store.select(getSplitUnbilledBalance).subscribe((value) => {
          if (value) {
            const splitbillData: SplitUnbilledBalance = value;
            const lastUpdateDate = new Date(
              splitbillData.employeeContribution.employeeAmount.lastUpdate,
            ).toLocaleString(this.languageService.getSelectedLanguage(), {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
            });
            this.employeeTotalAmount =
              splitbillData.employeeContribution.totalEmployeeContributionAmountInclVAT;
            this.employerTotalAmount =
              splitbillData.employerContribution.totalEmployerContributionAmountExclVAT;
            this.employeeInvoice =
              splitbillData.employeeContribution.employeeAmount.amountInclVAT;

            this.lastUpdate = this.translationService
              .getTranslatedValueFor('mobile.splitBill.update')
              .replace('{0}', lastUpdateDate);

            this.mobilePayment =
              splitbillData.employeeContribution.mobilePayment.amountInclVAT;

            this.currencyUnit = '€';
          }
        }),
      );

      this.translationService.parse(this.elementRef.nativeElement);
    }
    this.inceptionService.init();
    this.scrollToTop();
  }

  private scrollToTop(): void {
    setTimeout(() => {
      this.inceptionService.scrollToElement('#splitBillDetails');
    });
  }
}
